import React from 'react'
import { useTranslation } from 'next-i18next'
import config from '../config/config'
import './Footer.scss'

const Footer = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h5>{t('footer.contact', 'Contact')}</h5>
            <p>
              <a href={`mailto:${config.APP.SUPPORT_EMAIL}`}>
                {config.APP.SUPPORT_EMAIL}
              </a>
            </p>
          </div>
          
          <div className="footer-section">
            <h5>{t('footer.about', 'About PianoMeetups')}</h5>
            <p className="text-muted">
              {t('footer.description', 'Connecting piano enthusiasts through music and community.')}
            </p>
          </div>
          
          <div className="footer-section">
            <h5>{t('footer.legal', 'Legal')}</h5>
            <ul className="footer-links">
              <li>
                <a href="/#/privacy" target="_blank" rel="noopener noreferrer">
                  {t('footer.privacy', 'Privacy Policy')}
                </a>
              </li>
              <li>
                <a href="/#/terms" target="_blank" rel="noopener noreferrer">
                  {t('footer.terms', 'Terms of Service')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="text-muted">
            © {currentYear} {config.APP.NAME}. {t('footer.rights', 'All rights reserved.')}
          </p>
          <p className="text-muted version">
            v{config.APP.VERSION}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer